import { render } from "./addcategoryBlogs.vue?vue&type=template&id=58f35a40&scoped=true"
import script from "./addcategoryBlogs.vue?vue&type=script&lang=js"
export * from "./addcategoryBlogs.vue?vue&type=script&lang=js"

import "./addcategoryBlogs.vue?vue&type=style&index=0&id=58f35a40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f35a40"]])

export default __exports__